<template>
  <div class="home">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px"></div>
    <div class="box">
      <div class="currency_box">
        <div class="kc_list font24">{{pageType=='course'?'课程列表':'案例列表'}}</div>
        <div class="top_nav_list">
          <div :class="data.courseType == item.value?'activeIndex':'top_nav_item'"
               v-for="(item,index) in top_nav"
               :key="index"
               @click="topNavClick(item)">{{item.text}}</div>
        </div>
      </div>
    </div>
    <div class="currency_box"
         style="min-width: 1200px;"
         v-loading="loading">
      <el-tabs :tab-position="tabPosition"
               v-if="pageType == 'course'"
               v-model="calssifyIndex"
               @tab-click="tabClick"
               :style="{'minHeight':loading?'1000px':''}"
               style="width: 100%;">
        <el-tab-pane :label="item.name"
                     v-if="data.courseType != 2"
                     v-for="(item,index) in calssifyList"
                     :key="index">
        </el-tab-pane>
        <curriculumItem status="paging"
                        :data="courseData"
                        @currrntChange="currrntChange"></curriculumItem>
      </el-tabs>
      <el-tabs :tab-position="tabPosition"
               v-model="calssifyIndex"
               v-if="pageType == 'article'"
               @tab-click="tabClick"
               style="width: 100%;"
               :style="{'minHeight':loading?'1000px':''}">
        <el-tab-pane :label="item.text"
                     v-for="(item,index) in calssifyList"
                     :key="index">
          <Item :data="article"
                @currrntChange="currrntChange"></Item>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import curriculumItem from '@/components/OnlineBusinessSchool/curriculum_item.vue'
import Item from '../Cooperationcases/components/item.vue'
import { courseClassify, courseList, dictTypeList, projectClassify, allArticleList } from '@/api/api.js'
export default {
  components: { curriculumItem, Item },
  data () {
    return {
      tabPosition: 'top',
      loading: false,
      courseData: {},
      top_nav_index: 0,
      top_nav: [{ text: '商学院系列课', value: 1 }, { text: '线上训练营', value: 2 }],
      data: {  //课程
        classifyIds: '',
        courseType: 1,
        pageNumber: 1,
        pageSize: 12
      },
      articleData: {  //文章
        articleClassify: '',
        pageNumber: 1,
        pageSize: 9
      },
      article: {},
      articleClassifyList: [],  //文章分类字典项list
      calssifyList: [], //文章分类
      calssifyIndex: 0,
      pageType: 'course'
    }
  },
  created () {
    if (this.$route.query.type == 'article') {
      this.pageType = 'article';
      this.top_nav = [{ text: '全部', value: '' }, { text: '活动案例', value: 1 }, { text: '项目案例', value: 2 }]
      this.data.courseType = ''
      this.getDictTypeList()
    } else {
      this.getcourseClassify('init')
    }
  },
  methods: {
    // 字典项 ow_article_classify
    async getDictTypeList () {
      const res = await dictTypeList('ow_article_classify')
      this.articleClassifyList = res.data
      this.getprojectClassify()
      console.log(res)
    },
    async getprojectClassify () {
      const res = await projectClassify(this.data.courseType)
      let list = res.data;
      if (list && list.length != 0) {
        list.forEach((x, y) => {
          this.articleClassifyList.forEach((item, index) => {
            if (item.paramValue == x.articleClassifyIds) {
              x['text'] = item.paramName
            }
          })
        })
      }
      this.calssifyList = list;
      if (this.calssifyList && this.calssifyList.length != 0) {
        this.articleData.articleClassify = this.calssifyList[0].articleClassifyIds
        this.getallArticleList()
      }
      console.log(this.calssifyList)
    },
    async getcourseClassify (type) {  //获取课程分类
      const res = await courseClassify()
      console.log(res)
      let list = res.data;
      let arr = [{
        name: '全部',
        id: ''
      }]
      this.calssifyList = arr.concat(list);
      console.log(this.calssifyList)
      if (type == 'init') {
        // this.data.classifyIds = this.calssifyList[0].id;
        this.getcourseList()
      }
    },
    currrntChange (e) {  //分页改变
      if (this.pageType == 'course') {
        this.data.pageNumber = e;
        this.getcourseList()
      } else {
        this.articleData.pageNumber = e;
        this.getallArticleList()
      }
    },
    async getcourseList () {  //课程列表
      this.loading = true;
      const res = await courseList(this.data)
      let arr = {
        bg: '#f5f5f5',
        itembg: '#fff',
        status: 'paging'
      }
      this.courseData = { ...arr, ...res.data };
      this.loading = false;
      console.log(this.courseData)
    },
    async getallArticleList () { //
      console.log(this.articleData)
      this.loading = true;
      const res = await allArticleList(this.articleData)
      let arr = {
        bg: '#f5f5f5',
        itembg: '#fff',
        status: 'paging'
      }
      this.article = { ...arr, ...res.data }
      this.loading = false;
      console.log(this.article)

    },
    topNavClick (item) {
      this.data.courseType = item.value
      this.calssifyIndex = '0';
      if (this.pageType == 'course') {
        this.data.pageNumber = 1;
        if (this.data.courseType == 2) {
          this.data.classifyIds = ''
        }
        this.getcourseList()
      } else {
        this.articleData.pageNumber = 1;
        this.getDictTypeList()
      }
    },
    tabClick (e) {
      if (this.pageType == 'course') {
        this.data.classifyIds = this.calssifyList[Number(e.index)].id;
        this.data.pageNumber = 1;
        this.getcourseList()
      } else {
        console.log(this.calssifyIndex)
        console.log(this.calssifyList[Number(e.index)])
        this.articleData.articleClassify = this.calssifyList[Number(e.index)].articleClassifyIds;
        this.articleData.pageNumber = 1;
        this.getallArticleList()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  // min-height: 100vh;
  .box {
    min-width: 1200px;
    padding: 20px 0;
    box-sizing: border-box;
    background-color: #de1f26;
    color: #fff;
    .kc_list {
      font-weight: bold;
      padding-right: 18px;
      border-right: 1px solid #fff;
    }
    .top_nav_list {
      flex: 1;
      display: flex;
      padding-left: 30px;
      justify-content: flex-start;
      .top_nav_item {
        margin-right: 15px;
        background-color: #de1f26;
        padding: 8px 15px;
        color: #fff;
        box-sizing: border-box;
        border-radius: 16px;
        cursor: pointer;
      }
      .activeIndex {
        margin-right: 15px;
        background-color: #fff;
        padding: 8px 15px;
        color: #de1f26;
        box-sizing: border-box;
        border-radius: 16px;
      }
    }
  }
}
</style>
